export default __webpack_public_path__ + "static/media/prev-E1A-1.ea7b3e0f.png";